<template>
  <div>
    <div class="no-result-wrap d-flex justify-content-center align-items-center"
    :class="{background}" v-if="large === false">
      <i class="far fa-folder-open mr-2"></i>
      <span>No results to display.</span>
    </div>
    <div class="no-result-wrap py-4 d-flex justify-content-center align-items-center"
    :class="{background}" v-else>
      <div class="no-r-wrap d-flex justify-content-center align-items-center mr-3">
        <i class="fas fa-folder-open"></i>
      </div>
      <div class="d-flex justify-content-center flex-column">
        <div style="line-height: 12px; font-size: 16px; margin-top: 5px">No results to display.</div>
        <div style="font-weight: 400">Please modify your criteria or filters.</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    background: {
      type: Boolean,
      default: true,
    },
    large: {
      type: Boolean,
      default: false,
    }
  },
}
</script>

<style lang="scss">
.no-r-wrap{
  height: 40px;
  width: 40px;
  border-radius: 100%;
  background-color: rgb(196, 196, 196);

   i{
     color: rgb(92, 92, 92) !important;
   }
}
.no-result-wrap {
  color: #4a4a4a;
  padding: 0.625rem;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 600;

  &.background{
    background-color: #ebebeb;
    margin-bottom: 0.5rem;
  }

  i {
    font-size: 1.125rem;
  }
}
</style>
